// extracted by mini-css-extract-plugin
module.exports = {"label":"SizeLabel_label__A_Ysu","selected":"SizeLabel_selected__DWlNa","selectedSize":"SizeLabel_selectedSize__9xHhS","sublabel":"SizeLabel_sublabel__lH_ox"};